const cursor = document.querySelector(".custom-cursor");

const xSet = gsap.quickSetter(cursor, "x", "px");
const ySet = gsap.quickSetter(cursor, "y", "px");

let mouseX = innerWidth / 2;
let mouseY = innerHeight / 2;

let x = mouseX;
let y = mouseY;

window.addEventListener("pointermove", (e) => {
  mouseX = e.clientX;
  mouseY = e.clientY;
});

gsap.ticker.add(() => {

  x += (mouseX - x) * 0.15;
  y += (mouseY - y) * 0.15;

  xSet(x);
  ySet(y);

});


const hoverTargets = `
a,
button,
.btn,
summary,
input,
select,
textarea,
[role="button"]
`;

document.addEventListener("pointerenter", (e) => {
  if (!e.target.closest(hoverTargets)) return;

  gsap.to(cursor, {
    width: 50,
    height: 50,
    // borderWidth: "6px",
    // borderColor: "#F0765A",
    // background: '#F0765A00',
    mixBlendMode: 'color-burn',
    duration: 0.3,
    ease: "power3.out"
  });

}, true);

document.addEventListener("pointerleave", (e) => {
  if (!e.target.closest(hoverTargets)) return;

  gsap.to(cursor, {
    width: 18,
    height: 18,
    // borderWidth: "0",
    // background: '#F0765A',
    mixBlendMode: 'normal',
    duration: 0.3,
    ease: "power3.out"
  });

}, true);

const iframe = document.querySelector("iframe");

iframe.addEventListener("mouseenter", () => {
  gsap.to(cursor, {
    autoAlpha: 0,
    duration: 0.2
  });
});

iframe.addEventListener("mouseleave", () => {
  gsap.to(cursor, {
    autoAlpha: 1,
    duration: 0.2
  });
});